export default __webpack_public_path__ + "img/6720e9bddd56046aa4f02ffe8cf48af0.svg";